export default __webpack_public_path__ + "static/media/logo-md-480w.394bc917.png";